import { deleteRequest, get, post, put } from '../../helpers/apihelpers';

const buildQueryString = (filters = {}) => {
    const params = new URLSearchParams();

    Object.entries(filters).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
            params.append(key, value);
        }
    });

    const query = params.toString();
    return query ? `?${query}` : '';
};

export const CreateChapterService = async (data) => {
    try {
        const result = await post('api/admin/chapter/create', data);
        return result;
    } catch (err) {
        return err.response;
    }
};

export const UpdateChapterService = async (data, id) => {
    try {
        const result = await put(`api/admin/chapter/update/${id}`, data);
        return result;
    } catch (err) {
        return err.response;
    }
};

export const GetChapterService = async (filters = {}) => {
    try {
        const result = await get(`api/admin/chapter/get${buildQueryString(filters)}`);
        return result;
    } catch (err) {
        return err.response;
    }
};

export const DeleteChapterService = async (id) => {
    try {
        const result = await deleteRequest(`api/admin/chapter/delete/${id}`);
        return result;
    } catch (err) {
        return err.response;
    }
};
